import ProductoCreateOfertaModal from './ProductoCreateOfertaModal.vue'

export default ProductoCreateOfertaModal

